import { Component, OnInit, OnDestroy } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar"
import { FuseConfigService } from '../../../../@fuse/services/config/config.service';
import { FuseNavigationService } from "../../../../@fuse/components/navigation/navigation.service";
import { fuseAnimations } from '../../../../@fuse/animations';
import { ForgotPasswordModel  } from '../authentication.model';
import { AuthenticationService } from '../authentication.service';
import { AppConfig } from '../../../app.config';
import { NotificationService } from '../../../shared/services/notification.service';
import { ValidationService } from "../../../shared/services/validation.service";
import {GlobalCompanyService} from "../../../shared/component/global-company/global-company.service";
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
  animations: fuseAnimations
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  frmForgotPassword: FormGroup;
  isForgotPasswordSuccessfull: boolean = false; 

  notificationService: NotificationService;
  isSubmitBtnDisabled: boolean = false;
 
  apiResponseErrorMessage:string=null;
  myEmail:string=null;
  private unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private readonly router: Router,
    private readonly snb: MatSnackBar,
    private readonly fuseConfigService: FuseConfigService,
    private readonly formBuilder: FormBuilder,
    private readonly authenticationservice: AuthenticationService,
    private readonly appConfig: AppConfig,
    private spinner: NgxSpinnerService,
    private readonly location: LocationStrategy,
    private readonly fuseNavigationService: FuseNavigationService,
    private readonly globalCompanyService: GlobalCompanyService,
    private cookieService: CookieService,
  ) {
    
    this.notificationService = new NotificationService(snb);
    this.unsubscribeAll = new Subject();

  
    // Configure the layout
    this.fuseConfigService.config={
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.frmForgotPassword = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.emailValidator]]
    });
  }

  forgotPassword() {
    this.apiResponseErrorMessage = null;
    var forgotPasswordModel = new ForgotPasswordModel();
    forgotPasswordModel.email = this.frmForgotPassword.controls.email.value;
    if (this.frmForgotPassword.valid) {
      this.isSubmitBtnDisabled = true;
      this.spinner.show();
      this.authenticationservice.forgotPassword(forgotPasswordModel).subscribe(result => {
        this.spinner.hide();
        this.isSubmitBtnDisabled = false;
        if (result.status === 1) {
          this.isForgotPasswordSuccessfull = true;
          this.myEmail = this.frmForgotPassword.controls.email.value;
        }
        if (result.status === 2) {
          this.apiResponseErrorMessage = result.message;
        }
        else if (result.status === 0) {
          this.apiResponseErrorMessage = result.message;
        }
      });
    };
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next('');
    this.unsubscribeAll.complete();
  }
}
